import { useEffect, useState } from 'react'
import { firebaseHandler } from '../../../firebase/firebaseHandler'
import { BlogSummaries } from '../../App'
import MarkDown from './CodeEditor/MarkDown'
import './createpost.css'

const CreatePost = (props: any) => {
    const [titleValue, setTitleValue] = useState(localStorage.title || '')
    const [summaryValue, setSummaryValue] = useState(localStorage.summary || '')
    const [contentValue, setContentValue] = useState(localStorage.content || '')
    const { setWhichPageChild, contents, setContents } = props;
    const onFormSubmit = (e: any) => {
        e.preventDefault()
        let answer = prompt('Enter Admin Credentials')
        
        firebaseHandler.checkPassword(answer).then(canPass => {
            if(canPass.data) {
                const data = new FormData(e.target)
                // console.log(`here is our title: ${data.get('form-title')}, our summary: ${data.get('form-summary')}, and our content: ${data.get('form-content')}`)
                let newPostData = {
                    title: data.get('form-title'),
                    summary: data.get('form-summary'),
                    content: data.get('form-content'),
                }
                firebaseHandler.createPost(newPostData).then(newPost => {return newPost})
            }
            else {
                alert('This is meant for an admin')
            }
        })
        
    }
    useEffect(() => {
       window.onload = onWindowLoad;
       if(!localStorage.title || localStorage.title === '') {
           firebaseHandler.grabIncompletePost().then((post) => {
               setTitleValue(post.title)
               setSummaryValue(post.summary)
               setContentValue(post.content)
           })
       }
    }, [])
    const onWindowLoad = () => {
        setWhichPageChild('newPost')
        if(localStorage.title) setTitleValue(localStorage.title)
        if(localStorage.summary) setSummaryValue(localStorage.summary)
        if(localStorage.content) setContentValue(localStorage.content)
    }
    const onTitleChange = ({target}: any) => {setTitleValue(target.value); localStorage.title = target.value; console.log(localStorage.title)}
    const onSummaryChange = (summary: string) => {setSummaryValue(summary); localStorage.summary = summary; console.log(localStorage.summary)}
    const onContentChange = (content: string) => {setContentValue(content); localStorage.content = content; console.log(localStorage.content)}
    // console.log(`Here is our content: ${contentValue}, our summary: ${summaryValue} and our title: ${titleValue}`)
   
    const [editMode, setEditMode] = useState(false)
    const [postId, setPostId] = useState(0)
    const enterEditMode = () => {
        let answer = prompt('Enter Admin Credentials')
        if(answer === null) return;
        firebaseHandler.checkPassword(answer).then(canPass => {
            if(canPass) {
                localStorage.ID = 1; setPostId(1);
                localStorage.title = contents[0].data.title; setTitleValue(contents[0].data.title);
                localStorage.summary = contents[0].data.summary; setSummaryValue(contents[0].data.summary);
                localStorage.content = contents[0].data.content; setContentValue(contents[0].data.content);
                setEditMode(true)
            } else {
                alert('This is meant for Admin')
            }
        })
    }
    const loadDataForEditor = (ID: number) => {
        contents.map((post: BlogSummaries) => {
            const {title, summary, content, id} = post.data;
            if(id === ID) {
                if(postId !== post.data.id || localStorage.ID !== post.data.id) {
                    let answer: string | null = prompt('Make sure to save your data. Navigate Away? y'); 
                    if(answer === 'y' || answer === 'Y') {
                        setTitleValue(title); localStorage.title = title;
                        setSummaryValue(summary); localStorage.summary = summary;
                        setContentValue(content); localStorage.content = content;
                        setPostId(ID); localStorage.ID = ID;
                    } else return;
                } else {
                    setTitleValue(title); localStorage.title = title;
                    setSummaryValue(summary); localStorage.summary = summary;
                    setContentValue(content); localStorage.content = content;
                    setPostId(ID); localStorage.ID = ID;
                }
                
            }
        })
    }
    const saveData = () => {
        if(titleValue === '') return;
        let savedData = {
            id: postId,
            title: titleValue,
            summary: summaryValue,
            content: contentValue,
        }   
        firebaseHandler.savePost(savedData).then(content => {
            setContents(content)
        })
    }
    const saveIncomplete = () => {
        if(titleValue === '') return;
        let currentData = {
            title: titleValue,
            summary: summaryValue,
            content: contentValue,
        }
        firebaseHandler.saveIncompletePost(currentData).then(result => {
            return result;
        })
    }
    return (
    <div className={'create-hugger'}>
        <div className={'editor-bar'}>
            <button onClick={enterEditMode}>
                <span className="material-icons">edit</span>
            </button>
            {editMode && contents.map((post: BlogSummaries, i: number) => {
                return (
                    <button 
                    style={
                        (postId === post.data.id || localStorage.ID === post.data.id) 
                        ? {backgroundColor: '#afb8bd'} 
                        : {}
                    } 
                    onClick={() => {loadDataForEditor(post.data.id)}}>{`Post-${post.data.id}`}</button>
                );
            })}
            {editMode 
            ? <button onClick={saveData}><span className="material-icons">save</span></button> 
            : <button onClick={saveIncomplete}><span className="material-icons">save</span></button>
            }
        </div>

        
        <div className={'create-wrapper'}>
            <form id={'create-post'} onSubmit={onFormSubmit}>
                <div className={'form-header'}>
                    {editMode && <h4><i>Entered editor mode</i></h4>}
                    <h4><i>Note: Summary and Content will be dangerously inserted with predetermined styling based on the tags used</i></h4>
                    <label htmlFor="form-title"><p>Enter Title of the Blog:</p></label>
                    <input value={titleValue} onChange={onTitleChange} id="form-title" name="form-title" type="text" />
                </div>
                <div className={'form-summary'}>
                    <input id="form-summary" name="form-summary" type={'hidden'} value={summaryValue} />
                </div>
                <div className={'form-content'}>
                    <input id="form-content" name="form-content" type={'hidden'} value={summaryValue} />
                </div>
                <button style={{left: (window.innerWidth/2)-100}} id={'form-button'}>Create Blog Post!</button>
            </form>
            <div className={'summary-markdown'}>
                <p>Enter Summary of the Blog:</p>
                <MarkDown 
                value={summaryValue}
                setValue={onSummaryChange}
                height={200}
                />
            </div>
            <div className={'content-markdown'}>
                <p>Enter Content of the Blog:</p>
                <MarkDown 
                value={contentValue}
                setValue={onContentChange}
                height={600}
                />
            </div>
        </div>
    </div> 
    );
}
export default CreatePost;